import { AuthRemoteDataSource, type ExchangeTokenPayload, type ProfileResponse, type TokenResponseWrapper } from "../datasources/authRemoteDataSource";

export class AuthRepository {
  private readonly remoteDataSource = new AuthRemoteDataSource();

  async exchangeToken(payload: ExchangeTokenPayload): Promise<TokenResponseWrapper> {
    return await this.remoteDataSource.exchangeToken(payload);
  }

  async getProfile(): Promise<ProfileResponse> {
    return await this.remoteDataSource.getProfile();
  }
}
